<template>
    <teleport v-if="open" to="body">
        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-if="open" class="fixed inset-0 z-[99999] bg-black/40 backdrop-blur-[2px] flex items-center justify-center p-4">
                <WheelConfetti />
                <div
                    class="w-full max-w-[500px] max-h-[90vh] bg-white rounded-[20px] shadow-2xl flex flex-col overflow-hidden relative"
                    role="dialog"
                    aria-modal="true"
                    aria-label="HKCM-Glücksrad 2026"
                >
                    <button
                        class="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-full text-xl text-gray-400 hover:bg-gray-100"
                        aria-label="Schließen"
                        @click="$emit('close')"
                    >
                        ×
                    </button>

                    <div class="overflow-y-auto flex flex-col gap-[24px] p-[30px]">
                        <div class="flex items-center gap-0 sm:gap-1 -ml-3 sm:-ml-4 -mb-3">
                            <div class="relative h-[120px] w-[120px] sm:h-[140px] sm:w-[140px] shrink-0 overflow-hidden -mr-1 sm:mr-0">
                                <img :src="$asset('/hkcm/images/WheelOfFortuneSimple.png', 'public')" alt="Das HKCM-Glücksrad" class="absolute inset-0 h-full w-full object-contain scale-[1.32]" />
                            </div>
                            <h2 class="font-bold text-[28px] leading-[120%] text-[#006CFF]">HKCM-Glücksrad 2026</h2>
                        </div>

                        <div class="rounded-[10px] flex flex-col gap-3 p-4 text-center bg-[#ECFDF5] border border-[rgba(38,117,94,0.5)]">
                            <span class="font-bold text-[17px] leading-[130%] text-[#26755E]">Herzlichen Glückwunsch!</span>
                            <p class="text-[15px] leading-[140%] text-[#1a4a3a]">
                                Sie haben folgenden Preis gewonnen:
                                <strong class="block text-lg mt-1">{{ currentPrize?.prize_title?.replace(/<\/?br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '') }}</strong>
                            </p>
                            <img v-if="currentPrizeImg" :src="currentPrizeImg" alt="" class="w-[180px] h-[180px] object-contain mx-auto" />
                        </div>
                                                                        <p class="text-[14px] leading-[140%] text-[#006CFF] text-center -mt-1 font-bold">Einlösbar bis einschließlich 12.06.2026.</p>


                        <p class="text-gray-700 text-[15px] leading-[150%]">
                            Wir kontaktieren Sie demnächst per E-Mail, um Ihnen Ihren Preis zuzusenden. Sie haben sich außerdem für die Verlosung der Hauptpreise qualifiziert.
                            Vielen Dank für Ihre Teilnahme!
                        </p>

                        <div class="p-4 rounded-xl bg-[linear-gradient(135deg,#fffbeb_0%,#fef3c7_100%)] border border-[#fde68a]">
                            <p class="flex items-start gap-2 text-gray-700 text-[14px] leading-[150%]">
                                <span class="text-xl shrink-0">💡</span>
                                <span><strong>Tipp:</strong> Je häufiger Sie bestellen, desto höher Ihre Chance auf die Hauptpreise!</span>
                            </p>
                        </div>

                        <FormButton class="text-center mx-auto" styling="primary" :value="$t('go_to_dashboard')" @click="router.push('/dashboard')" />
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script setup>
import { useRouter } from 'vue-router';
import WheelConfetti from './WheelConfetti.vue';

defineProps({
    open: { type: Boolean, required: true },
    currentPrize: { type: Object, default: null },
    currentPrizeImg: { type: String, default: null }
});

defineEmits(['close']);

const router = useRouter();
</script>
